import { put } from 'redux-saga/effects';

import { ContentSpaceInfo,EnterContentSpaceAction, enterSpace } from '~src/app/actions/spaces/EnterSpaceAction';
import { getAppStore } from '~src/app/AppStore';
import { NavLocationAreas } from '~src/app/layout/NavLocation';
import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { SpaceInfo } from '~src/app/state/SpaceInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { LocationTypes } from '~src/ts/models/ILocationInfo';


export function* handleEnterContentSpace(action: EnterContentSpaceAction) {
  if (action.contentSpaceInfo) {
    const contentSpaceInfo: ContentSpaceInfo = action.contentSpaceInfo;
    const defaultSpaceInfo: SpaceInfo = {
      item: contentSpaceInfo.item,
      spaceType: contentSpaceInfo.spaceType,
      subspaceName: contentSpaceInfo.subspaceName
    };
    if (FeatureFlags.personalSpaceEnabled) {
      if (contentSpaceInfo.contentLocation === LocationTypes.PersonalSpace && SessionUserSelectors.sessionUserId(getAppStore().getState()) === contentSpaceInfo.ownerId) {
        const spaceInfoForPersonalSpace: SpaceInfo = {
          item: contentSpaceInfo.item,
          spaceType: contentSpaceInfo.spaceType,
          subspaceName: contentSpaceInfo.subspaceName,
          navLocationOverride: NavLocationAreas.SiteContent.personal_space
        };
        yield put(enterSpace(spaceInfoForPersonalSpace));
      } else {
        yield put(enterSpace(defaultSpaceInfo));
      }
    } else {
      yield put(enterSpace(defaultSpaceInfo));
    }
  }
  }